var Bio = function(options){

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

};

Bio.prototype.init = function(){

  let $vcardLink = this.options.$el.find(`.vcard.link`);

  $vcardLink.on('click', function() {

	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: 'download_vcard',
		event_category: 'engagement'
	});

  });

};

export default  Bio;
